import React from 'react';
import Logo from "../../components/Logo";
import Hamburger from "../Hamburger";

import block from "bem-css-modules";
import header from "../../styles/components/Header.module.scss";

function Header({ subscriptions, subscriptionInfo, userDetails, signupBook, authKeys, noBackground, modifiers, outBanner, searchIcon, openState }){
    
    block.setSettings({
        modifierDelimiter: "--",
      });
    
    const head = block(header);
    
    let variant = {};			
    variant[`${modifiers}`] = true;

    return(
        <div className={head("")}>
            <div className={head("items", {...variant})}>
                <div className={head("logo")}><Logo /></div>
                <div className={head("hamburgerMenu")}>
                    <Hamburger 
                        authKeys={authKeys} 
                        subscriptions={subscriptions} 
                        subscriptionInfo={subscriptionInfo} 
                        userDetails={userDetails} 
                        signupBook={signupBook} 
                        noBackground={noBackground}
                        outBanner={outBanner}
                        searchIcon={searchIcon}
                        openState={openState}/>
                </div>
            </div>
        </div>
    )
}

export default Header;